export default "__VITE_ASSET__CU6eELtr__"